import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import dismissibleStyles from '../Dismissible.module.scss'
import styles from './Description.module.scss'

/**
 * The `Description`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Description = forwardRef((props, forwardedRef) => {
  const { children, className } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () =>
      classNames([
        className,
        dismissibleStyles.description,
        styles.description
      ]),
    [className]
  )

  return (
    <p ref={ref} className={classNameOutput}>
      {children}
    </p>
  )
})

// Display name
Description.displayName = 'Description'

Description.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

// Memoize
export default memo(Description)
